import { useCallback } from 'react';
import { hasCTA } from '@core/helpers/video/hasCTA';
import { useContextParams } from '@core/params/context';
import { WidgetSizeEnum } from '@core/types';
import { useStore } from '@core/widgets/store';
import { appContextSelector } from '@core/widgets/store/selectors';
import { useTrackPlayerDeckProductCardImpression } from '@core/widgets/tracking/useTrackPlayerDeckProductCardImpression';
import { RESPONSIVE_THUMBNAIL_WIDTHS } from '@embed/components/Grid/GridConstants';
import { getThumbnailSize, PRODUCT_CARD_HEIGHT, } from '@embed/components/helpers/getThumbnailSize';
import { useFirstPartyLiveStream } from '@embed/hooks/useFirstPartyLiveStream';
import { PLAYER_DECK_THUMBNAIL_CONTAINER } from '@player/testIds';
import { StyledThumbnailContainerV2, ThumbnailContainer, } from './PlayerDeckContainer.styles';
import { PlayerDeckCTA } from './PlayerDeckCTA';
import { PlayerDeckLivestreamCTA } from './PlayerDeckLivestreamCTA';
import { ProductListContainer } from './ProductList';
/**
 * Product Card Carousel Container
 */
export const PlayerDeckContainer = ({ children, video, columnWidth, responsive }) => {
    const videoHasProducts = video?.products?.length > 0;
    const params = useContextParams();
    const appContext = useStore(appContextSelector);
    const { isFirstPartyLiveStream } = useFirstPartyLiveStream({
        appContext,
        params,
        video,
    });
    const hasInteractions = videoHasProducts || hasCTA(video) || isFirstPartyLiveStream;
    const [videoThumbWidth, videoThumbHeight] = getThumbnailSize(params.size);
    const trackProductCardImpression = useTrackPlayerDeckProductCardImpression(video);
    const onCardVisibilityChange = useCallback((isVisible, product) => {
        trackProductCardImpression(isVisible, product);
    }, [trackProductCardImpression]);
    const size = params.size ?? WidgetSizeEnum.LARGE;
    const thumbnailWidth = RESPONSIVE_THUMBNAIL_WIDTHS[size];
    return (<StyledThumbnailContainerV2 height={hasInteractions
            ? videoThumbHeight + PRODUCT_CARD_HEIGHT
            : videoThumbHeight} className={`scrollTo_${video.encoded_id}`} data-testid={PLAYER_DECK_THUMBNAIL_CONTAINER} responsive={responsive} columnWidth={columnWidth} maxWidth={thumbnailWidth.maxThumbWidth} minWidth={thumbnailWidth.minThumbWidth}>
      <ThumbnailContainer height={videoThumbHeight} width={videoThumbWidth} responsive={responsive}>
        {children}
      </ThumbnailContainer>
      {videoHasProducts && (<ProductListContainer video={video} onCardVisibilityChange={onCardVisibilityChange}/>)}
      {hasCTA(video) && (<PlayerDeckCTA video={video} params={params} appContext={appContext}/>)}
      {isFirstPartyLiveStream && video?.video_type === 'live_stream' && (<PlayerDeckLivestreamCTA video={video} params={params} appContext={appContext}/>)}
    </StyledThumbnailContainerV2>);
};
